module.exports = {
  getWinnerList: () => {
    const configs = window.app_configs
    let ptName = 'friday'
    let ptCode = '00'

    if (window.vue_router.params && window.vue_router.params.partnerName) {
      const { partnerName, partnerCode } = window.vue_router.params
      if (partnerName) {
        ptName = partnerName
      }
      if (partnerCode) {
        ptCode = partnerCode
      }
    }

    const apiPath = `${configs.mApiPath}event/cycle/buyerYesterday/${ptName}${ptCode}`

    return new Promise((resolve, reject) => {
      if (!window.turnWinnerData) {
        fetch(apiPath)
          .then((res) => res.json())
          .then((res) => {
            // remove repeat
            const newData = {
              code: res.code,
              data: res.data
            }
            window.turnWinnerData = newData
            console.log('winners number is ' + newData.data.length )
            resolve(newData)
          })
          .catch(() => {
            reject()
          })
      } else {
        resolve(window.turnWinnerData)
      }
    })
  },
}
